import { Dispatch } from 'react-redux';
import { AuthActionCreators, IApplicationState } from "../";
import { IListItem, IDonorConnectMentorPerformanceMonth, IMentorCompletionsList, IDonorConnectCompletionsReport, IDonorConnectGroup, IDonorConnectSurveyType } from '@nkr/models/index';
import { OrganType } from '@nkr/enums/organ-type';

export interface IDonorConnectCompletionsReportResponse {
    data: {
        success: boolean;
        results: IDonorConnectCompletionsReport[];
    }
}

export interface IDonorConnectMentorPerformanceResponse {
    data: {
        success: boolean,
        results: {
            monthlyStats: IDonorConnectMentorPerformanceMonth[],
            mentorList: IListItem[]
        }
    }
}

export interface IMentorCompletionsListResponse {
    data: {
        success: boolean,
        message: string,
        results: IMentorCompletionsList
    }
}

export const ActionCreators = {
    getDonorConnectCompletions: (year: number, month: number, csv: boolean) => async (dispatch: Dispatch<IApplicationState>): Promise<IDonorConnectCompletionsReportResponse> => {

        let options = {
            url: `${__API__}/donor-connect/report/completions/${year}/${month}/${csv}`
        };

        try {
            return await dispatch(AuthActionCreators.apiGet(options));
        } catch (error) {
            throw error;
        }
    },
    getMentorCompletionDetails: (year: number, month: number, userId: number) => (dispatch: Dispatch<IApplicationState>): Promise<IMentorCompletionsListResponse> => {
        let options = {
            url: `${__API__}/donor-connect/report/completions-details?year=${year}&month=${month}&userId=${userId}`
        };

        return dispatch(AuthActionCreators.apiGet(options))
            .then((response: IMentorCompletionsListResponse) => {
                return Promise.resolve(response);
            })
            .catch((error) => {
                throw error;
            });
    },
    getDonorConnectMentorPerformanceReport: (startDate: string = '', endDate: string = '', mentorId: number = 0, groupList: IDonorConnectGroup, typeList: IDonorConnectSurveyType, organType: OrganType | null = null) => async (dispatch: Dispatch<IApplicationState>): Promise<IDonorConnectMentorPerformanceResponse> => {
        var options = {
            url: `${__API__}/donor-connect/report`,
            data: {
                startDate,
                endDate,
                mentorId,
                groupList,
                typeList,
                organType
            }
        };

        return await dispatch(AuthActionCreators.apiPost(options))
            .then((response: IDonorConnectMentorPerformanceResponse) => {

                return Promise.resolve(response);
            })
            .catch((error) => {
                throw error;
            });
    },
}



